'use strict';
const json = require('../../builds/configuration.json');

module.exports = json;
